var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1D1E22",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.235 1.656a7.06 7.06 0 0 1-2.03.557A3.55 3.55 0 0 0 16.76.258a7.127 7.127 0 0 1-2.246.859A3.536 3.536 0 0 0 8.488 4.34 10.038 10.038 0 0 1 1.2.646a3.509 3.509 0 0 0-.478 1.777c0 1.227.624 2.31 1.572 2.943a3.536 3.536 0 0 1-1.601-.444v.044a3.54 3.54 0 0 0 2.835 3.467c-.296.08-.608.124-.931.124-.229 0-.45-.023-.666-.066a3.538 3.538 0 0 0 3.302 2.456 7.094 7.094 0 0 1-4.39 1.51c-.286 0-.567-.017-.844-.048A9.995 9.995 0 0 0 5.42 14c6.504 0 10.059-5.387 10.059-10.06l-.012-.457a7.06 7.06 0 0 0 1.768-1.827Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.793d21c7.svg";
export { ForwardRef as ReactComponent };